import { HHTextField } from '@hinge-health/react-component-library';
import Clear from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { useState } from 'react';
import { Controller } from 'react-hook-form';
import { formatLineBreakOrCsvInput } from '../../utils/bills-utils';
import { CSVInputFilterProps } from './filter-types';

export const CSVInputFilter = ({
  control,
  errors,
  name,
  label,
  disabled = false,
  showClearButton = true,
}: CSVInputFilterProps): JSX.Element => {
  const [rowHeight, setRowHeight] = useState(1);

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }): JSX.Element => (
        <HHTextField
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          layoutStyles={{ minWidth: 230, maxWidth: 230 }}
          hhVariant="variant-bypass"
          variant="standard"
          id={`csv-input-${name}`}
          label={label}
          disabled={disabled}
          multiline
          rows={rowHeight}
          value={value}
          onChange={(e): void => {
            if (e.target.value.length > 25) {
              setRowHeight(5);
            } else {
              setRowHeight(1);
            }
            onChange(
              e.target.value.length > 0
                ? formatLineBreakOrCsvInput(e.target.value)
                : [],
            );
          }}
          type="string"
          InputLabelProps={{ sx: { color: 'gray' } }}
          InputProps={{
            endAdornment: showClearButton && value.length > 0 && !disabled && (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={(): void => {
                    onChange([]);
                    setRowHeight(1);
                  }}
                  edge="end"
                >
                  <Clear fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
          error={Object.keys(errors?.[name] ?? {}).length !== 0}
          helperText={errors?.[name]?.message as string}
        />
      )}
    />
  );
};
